module.exports = __webpack_public_path__ + "media/audio28.243108cc.wav";